import React from 'react';
import './styles.scss';

// A plan's name in the AI colours (the gradient the Studio uses for AI moments). An
// `em`, not a `span`: the global type rule would force a span inside a title to UI size.
export default function PlanName({ children }) {
  return <em className="studio-plan-name">{children}</em>;
}

const MARK = '⁣';

// `t(key)` with its `{{plan}}` drawn as a PlanName, wherever the language puts it.
export function planText(t, key, name, values = {}) {
  const [before, ...after] = t(key, { ...values, plan: MARK }).split(MARK);
  if (!after.length) return before;
  return <>{before}<PlanName>{name}</PlanName>{after.join(name)}</>;
}
